(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.header = document.querySelector('.section-header');

      /*
        MRAK:
        Header is intentionally always sticky.
      */
      this.headerIsAlwaysSticky = true;

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );
        this.currentScrollTop = 0;

this.preventReveal = false;

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () =>
        (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }

    disconnectedCallback() {

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }

    createObserver() {

      let observer = new IntersectionObserver(
        (entries, observer) => {

          this.headerBounds =
            entries[0].intersectionRect;

          observer.disconnect();

        }
      );

      observer.observe(this.header);

    }

onScroll() {
  const scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop;

  if (
    this.predictiveSearch &&
    this.predictiveSearch.isOpen
  ) return;

  if (scrollTop > 20) {
    this.header.classList.add(
      'scrolled-past-header',
      'shopify-section-header-sticky'
    );
  } else {
    this.header.classList.remove(
      'scrolled-past-header',
      'shopify-section-header-sticky',
      'shopify-section-header-hidden'
    );
  }

  this.header.style.transform = 'none';
  this.currentScrollTop = scrollTop;
}

    hide() {

      /*
        Disabled intentionally:
        MRAK header always stays visible.
      */

      return;

    }

    reveal() {

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      this.header.style.transform = 'none';

    }

    reset() {

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

      this.header.style.transform = 'none';

    }

    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) =>
          disclosure.close()
      );

    }

    closeSearchModal() {

      this.searchModal =
        this.searchModal ||
        this.header.querySelector(
          'details-modal'
        );

      if (this.searchModal) {
        this.searchModal.close(false);
      }

    }

  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );


  } catch(e) { console.error(e); }
})();
})();
